function addToCartGTM(productTitle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'add_to_cart',
        'product': `${productTitle}`,
        'source': window.source
    });
}

function removeFromCartGTM(productTitle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'remove_from_cart',
        'product': `${productTitle}`,
        'source': window.source
    });
}


function productDescriptionExpandGTM(productDescription) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'product_description_expand',
        'product_description': productDescription,
        'source': window.source
    });
}


function recentPurchasesClickGTM(collectionHandle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'recent_purchases_click',
        'collection': collectionHandle,
        'source': window.source
    });
}

function pdpResourceClickGTM(productHandle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'pdp_resource_click',
        'resource_file': productHandle,
        'source': window.source
    });
}

function pdpBlogClickGTM(blogTitle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'pdp_blog_click',
        'blog_post': blogTitle,
        'source': window.source
    });
}


function collectionClickGTM(collectionTitle) {
    window.dataLayer.push({
        'event': 'collection_click',
        'collection': collectionTitle,
        'source': window.source
    });
}

function productClickGTM(productTitle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'product_click',
        'product': productTitle,
        'source': window.source
    });
}

function promotionViewGTM(promotion) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'promotion_view',
        'promotion': promotion,
        'source': window.source
    });
}

function promotionClickGTM(promotion) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'promotion_click',
        promotion: promotion,
        'source': window.source
    });
}

function saveCartGTM(cart) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": 'save_cart_draft',
        "draft_order": cart,
        'source': window.source
    });
}

function contactUsGTM(customerId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": 'contact_us_click',
        "customer_id": customerId || 'Anonymous',
        'source': window.source
    });
}

function viewCartGTM(cart) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": 'view_cart',
        "cart": cart,
        'source': window.source
    });
}

function clearCartGTM(cartItems) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'clear_Cart',
        'cart_items': cartItems,
        'source': window.source

    });
}

function faqclickGTM(faq){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event' : 'faq_accordion_click',
        'faq_accordion' : faq,
        'source': window.source
    })
}

function collectionOverviewClickGTM(collectionTitle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'collection_overview_click',
        'collection': collectionTitle,
        'source': window.source
    });
}

function trackBarcodeOpen(options) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event': 'barcode_scan_open',
        'is_logged_in': !!options.customer,
        'source': window.source
    });
}

function trackBarcodeScanStarts(options) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event': 'barcode_scan_start',
        'is_logged_in': !!options.customer,
        'source': window.source
    });
}

function trackBarcodeScanResult(options) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event': 'barcode_scan_result',
        'is_logged_in': !!options.customer,
        'barcode': options.scanResult || '',
        'source': window.source
    });
}

function trackBarcodeScanSuccess(options) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event': 'barcode_scan_success',
        'is_logged_in': !!options.customer,
        'barcode': options.scanResult || '',
        'product': options.scanProductTitle || '',
        'source': window.source
    });
}
